let cartToken; 
const maxSizeInBytes = 5 * 1024 * 1024; 
const fileInput1 = document.getElementById('fileInput1');
const fileInput2 = document.getElementById('fileInput2');
const statusElement = document.getElementById('statusTax');
const statusElementPo = document.getElementById('statusPO');

class cartUploadFile {
    constructor() {
        this.cartForm = document.querySelector('.cartUploadMainDiv');
        this.bindEvents();
        this.removeFilesCartOnLoad();
        if (window.globalVariables.cart.item_count <= 0) {
            document.querySelector('.preLoginDiv').classList.add('d-none');
            document.querySelector('.cartUploadMainDiv').classList.add('d-none');
        }
    }

    bindEvents() {
        this.validateFileInput("fileInput1", "error-message1", maxSizeInBytes);
        this.validateFileInput("fileInput2", "error-message2", maxSizeInBytes);
        this.fetchCartTokenAndUse();

        this.cartForm?.querySelectorAll('.cartFileUploader').forEach(each => {
            each.addEventListener('change', (event) => {
                this.handleFileUpload(event.target.files[0], event.target.id, event);
                this.fileChangeCustom(event);
            });
        });

        this.cartForm?.querySelectorAll(".removeFIle").forEach(each => {
            each.addEventListener('click', (event) => {
                this.fileRemove(event);
            });
        });

        document.querySelectorAll('input[name="paymentMethodsRadio"]').forEach(radio => {
            radio.addEventListener('change', (event) => this.showFileSelector(event));
        });

        document.querySelector("#poOrderNumber")?.addEventListener('input', (event) => this.showCheckOutButton(event));
        document.querySelector('.customCheckoutButton')?.addEventListener('click', () => this.updatePoNumber());
    }

    getSelectedPaymentMethod() {
        const selectedRadio = document.querySelector('input[name="paymentMethodsRadio"]:checked');
        return selectedRadio ? selectedRadio.value : '';
    }

    showCheckOutButton(event) {
        document.querySelector('.customCheckoutButton').classList.remove("d-none");
        document.querySelector('.checkoutButton').classList.add("d-none");

        if (event.target.value.trim() === "" && this.getSelectedPaymentMethod() === 'Invoice') {
            document.querySelector('.customCheckoutButton').classList.add('disabled');
        } else {
            document.querySelector('.customCheckoutButton').classList.remove('disabled');
        }
    }

    showFileSelector(event) {
        const selectedValue = this.getSelectedPaymentMethod();

        if (selectedValue === 'cards') {
            document.querySelector('.customCheckoutButton').classList.remove('disabled');
            document.querySelector('.checkoutButton').setAttribute('href', `/checkout/`);
        } else {
            if (document.querySelector('#poOrderNumber').value === '') {
                document.querySelector('.checkoutButton').setAttribute('href', `/checkout`);
                document.querySelector('.customCheckoutButton').classList.add('disabled');
            }
        }
    }

    fileChangeCustom(event) {
        if (event.target.value) {
            event.target.closest('.choose-file-parentSecond').querySelector(".removalFile").classList.remove("d-none");
            event.target.closest('.choose-file-parentSecond').querySelector(".choose-file-btnCustom").classList.add("d-none");
        }

        const fileInput = event.target;
        event.target.closest('.choose-file-parentSecond').querySelector(".fileValueCustom").innerText = fileInput.value.split("\\").pop();
        event.target.closest('.choose-file-parentSecond').querySelector(".fileValueCustom").classList.add('mt-3');
    }

    fileRemove(event) {
        this.removeFilesCart(event.target.closest('.choose-file-parentSecond').querySelector('.cartFileUploader').id);
        event.target.closest('.choose-file-parentSecond').querySelector(".cartFileUploader").value = "";
        event.target.closest('.choose-file-parentSecond').querySelector(".fileValueCustom").innerHTML = "";
        event.target.closest('.choose-file-parentSecond').querySelector(".fileValueCustom").classList.remove('mt-3');
        event.target.closest('.choose-file-parentSecond').querySelector(".removeFIle").classList.add("d-none");
        event.target.closest('.choose-file-parentSecond').querySelector(".choose-file-btnCustom").classList.remove("d-none");
    }

    removeFilesCartOnLoad() {
        const formData = {
            attributes: {
                po_order: '',
                tax_exempt: '',
                po_order_number: '',
                payment_type: ''
            }
        };

        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        })
        .then(response => {
            if (!response.ok) throw new Error('Failed to update cart attributes');
            return response.json();
        })
        .then(data => {
            const poOrderInput = document.querySelector('#poOrderNumber');
            if (poOrderInput) poOrderInput.value = '';
            document.querySelectorAll(".cartFileUploader")?.forEach(each => each.value = '');
            document.querySelector('#paymentCard').checked = true;
        })
        .catch(error => {});
    }

    removeFilesCart(id) {
        const formData = { attributes: {} };
        if (id === 'fileInput1') formData.attributes.po_order = '';
        else if (id === 'fileInput2') formData.attributes.tax_exempt = '';

        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        })
        .then(response => {
            if (!response.ok) throw new Error('Failed to update cart attributes');
            return response.json();
        })
        .catch(error => {});
    }

    validateFileInput(inputId, errorId, maxSizeInBytes, allowedTypes = []) {
        const input = document.getElementById(inputId);
        const errorMessage = document.getElementById(errorId);

        input?.addEventListener("change", function (event) {
            const file = event.target.files[0];

            if (file) {
                const fileType = file.type;
                const fileSize = file.size;

                if (fileSize > maxSizeInBytes || (allowedTypes.length && !allowedTypes.includes(fileType))) {
                    errorMessage.style.display = "block";
                    event.target.value = "";
                } else {
                    errorMessage.style.display = "none";
                }
            }
        });
    }

    async fetchCartTokenAndUse() {
        try {
            const response = await fetch('/cart.json');
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
            const cartData = await response.json();
            cartToken = cartData.token.split("?key=")[0];
            document.querySelector('.checkoutButton').setAttribute('href', `/checkout`);
        } catch (error) {}
    }

    async handleFileUpload(file, inputFieldId, event) {
        if (!file && inputFieldId === 'fileInput1' && event.target.value === '') {
            this.removeFilesCart('fileInput1');
            return;
        } else if (!file && inputFieldId === 'fileInput2' && event.target.value === '') {
            this.removeFilesCart('fileInput2');
            return;
        } else {
            const otherInput = inputFieldId === 'fileInput1' ? fileInput2 : fileInput1;
            const document_type = event.target.classList.contains('poOrder') ? 'po_order' : 'tax_exempt';

            otherInput.nextElementSibling.classList.add('disabled');
            otherInput.disabled = true;
            document.querySelector('.customCheckoutButton').classList.add('disabled');
            document.querySelector('#paymentCard').closest('#paymentMethods').setAttribute('disabled', '');

            if (inputFieldId === 'fileInput1') {
                statusElementPo.classList.remove('d-none');
                statusElementPo.textContent = `Uploading file ...`;
            } else {
                statusElement.classList.remove('d-none');
                statusElement.textContent = `Uploading file ...`;
            }

            const formData = new FormData();
            formData.append('file', file);
            formData.append("document_type", document_type);
            formData.append("cart_token", cartToken);

            try {
                const uploadResponse = await fetch('/apps/proxy/api/upload-file', {
                    method: 'POST',
                    body: formData,
                });

                if (uploadResponse.ok) {
                    const uploadResult = await uploadResponse.json();

                    if (inputFieldId === 'fileInput1') {
                        statusElementPo.textContent = `File uploaded successfully`;
                        setTimeout(() => statusElementPo.classList.add('d-none'), 2000);
                    } else {
                        statusElement.textContent = `File uploaded successfully`;
                        setTimeout(() => statusElement.classList.add('d-none'), 2000);
                    }

                    const formData = { attributes: {} };
                    formData.attributes[document_type] = uploadResult.fileUrl;

                    this.updateCartAttributes(formData, false);
                } else {
                    throw new Error('File upload failed');
                }
            } catch (error) {
                statusElement.textContent = `Error: ${error.message}`;
            } finally {
                otherInput.nextElementSibling.classList.remove('disabled');
                otherInput.disabled = false;
                if (document.querySelector('#poOrderNumber').value !== '' || this.getSelectedPaymentMethod() === 'cards') {
                    document.querySelector('.customCheckoutButton').classList.remove('disabled');
                }
                document.querySelector('#paymentCard').closest('#paymentMethods').removeAttribute('disabled');
            }
        }
    }

    async updatePoNumber() {
        const formData = {
            attributes: {
                po_order_number: document.querySelector("#poOrderNumber").value,
                payment_type: this.getSelectedPaymentMethod() === 'cards' ? 'cards' : 'invoice'
            }
        };

        const formDataTax = new FormData();
        var tax_exempt
        if(window.globalVariables.customerTax === true){
                 tax_exempt = true
        }else{
             tax_exempt = document.querySelector('#fileInput2').value ? true : false;
        }
        console.log(tax_exempt, 'tax_exempttax_exempttax_exempttax_exempttax_exempt');
        
        formDataTax.append('customer_id', window.globalVariables.customer);
        formDataTax.append('tax_exempt', tax_exempt);

        try {
            const uploadResponse = await fetch('/apps/proxy/api/tax-exempt', {
                method: 'POST',
                body: formDataTax,
            });

            if (!uploadResponse.ok) {
                throw new Error(`HTTP error! Status: ${uploadResponse.status}`);
            }

            const responseData = await uploadResponse.json();
            this.updateCartAttributes(formData, true);
        } catch (error) {}
    }

    updateCartAttributes(formData, needCheckout) {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        })
        .then(response => {
            if (!response.ok) throw new Error('Failed to update cart attributes');
            return response.json();
        })
        .then(data => {
            if (needCheckout === true) {
                document.querySelector('.checkoutButton').click();
            }
        })
        .catch(error => {});
    }
}

new cartUploadFile();
